import { CSVLink } from 'react-csv'

export const CSVDownloader = ({ data, headers, style }) => {
  return (
    <CSVLink data={data} headers={headers} asyncOnClick={true} style={style} className="tiny button">
        Download CSV
    </CSVLink>
  )
}
